import { BluetoothPairedDevicesService } from '@services/bluetooth/BluetoothPairedDevicesService'
import { BluetoothCoreService } from '@src/services/bluetooth/BluetoothCoreService'
import { BluetoothModalService } from '@src/services/bluetooth/BluetoothModalService'
import { PromiseUtils } from '@amzn/ihm-associate-tools-js-lib'

/**
 * Cross frame listener for bluetooth. It call bluetooth listener registered in Old seaward.
 *
 * @param {object} message - Object with the following structure:
 *  {
 *      data: {
 *          action: {string} - one of 'pairAndConnect', 'getLastPairedDevice', etc...
 *          parameters: {object} - object containing the parameters for the bluetooth call
 *      }
 *  }
 *  @return {Promise} - Promise for the specified action.
 */
export async function bluetoothListener (message: any) {

    const action = message && message.data && message.data.action
    const params = message && message.data && message.data.parameters
    const bluetoothModalObj = new BluetoothModalService()

    switch (action) {

    case 'pairWithOptions':
    /**
     * Attempts to pair a given Bluetooth device with options. Sets the last paired device
     * Immediately resolves if device is already paired.
     */
        return BluetoothCoreService.pairDeviceWithOptions(params)
    case 'connect':
    /**
     * Attempts to pair a given Bluetooth device with options.
     */
        return BluetoothCoreService.connectDevice(params)
    case 'getDeviceInfo':
    /**
     * Attempts to get information of the Bluetooth device.
     */
        return BluetoothCoreService.getDeviceInfo(params)
    case 'pairAndConnect':
    /**
     * Pairs and connects to the device by publishing an event to the BluetoothModalController.
     * This triggers a Bluetooth pair and connect modal to be displayed.
     */
        return bluetoothModalObj.pairAndConnectToDevice(params)
    case 'getLastPairedDevice':
    /**
     * API to get last paired device with the current device.
     */
        return BluetoothPairedDevicesService.getLastPairedDevice(params)
    case 'setLastPairedDevice':
    /**
     * API to set last paired device with the current device.
     */
        return BluetoothPairedDevicesService.setLastPairedDevice('', params)
    case 'clearLastPairedDevice':
    /**
     * Deletes the lastBluetoothPairedDevice for a given deviceType from localStorage
     */
        return BluetoothPairedDevicesService.clearLastPairedDevice(params)
    case 'clearAllLastPairedDevices':
    /**
     * Removes the entry for storing last bluetooth paired devices from local storage.
     * This removes all last paired devices for all device types.
     */
        return BluetoothPairedDevicesService.clearAllLastPairedDevices()
    }

    return PromiseUtils.newRejectedPromiseWithErrorMessage('Unsupported action: ' + action)
}
